import { useState } from 'react';

import AddCircleOutline from '@mui/icons-material/AddCircleOutline';
import { Button, Menu, MenuItem } from '@mui/material';

export const TEMPLATE_PLACEHOLDER_MENU_LABEL = 'Insert Placeholder';

type TemplatePlaceholderMenuProps = {
	placeholderNames: string[];
	onSelect: (name: string) => void;
	label?: string;
	variant?: 'text' | 'outlined';
};

export default function TemplatePlaceholderMenu({ placeholderNames, onSelect, label = TEMPLATE_PLACEHOLDER_MENU_LABEL, variant = 'text' }: TemplatePlaceholderMenuProps) {
	const [anchor, setAnchor] = useState<HTMLElement | null>(null);

	return (
		<>
			<Button size="small" startIcon={<AddCircleOutline />} variant={variant} onClick={(event) => setAnchor(event.currentTarget)} disabled={placeholderNames.length === 0}>
				{label}
			</Button>
			<Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
				{placeholderNames.map((name) => (
					<MenuItem
						key={name}
						onClick={() => {
							onSelect(name);
							setAnchor(null);
						}}
					>
						{'{{'}{name}{'}}'}
					</MenuItem>
				))}
			</Menu>
		</>
	);
}
